// removed by extract-text-webpack-plugin
module.exports = {"field":"required-fields-mapping__field-1i3V7 bitrix-export-leads__field-d_wKE","title":"required-fields-mapping__title-3mrI6 bitrix-export-leads__title-3raqM","listBox":"required-fields-mapping__listBox-12nKu bitrix-export-leads__listBox-2LL8h","content":"required-fields-mapping__content-33MDR","description":"required-fields-mapping__description-30eZO"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/bitrix-export-leads/required-fields-mapping/required-field-mapping.css
// module id = 754
// module chunks = 0